<template>
    <teleport to="#sl-order-tools__convert-prototype-button">
        <tippy placement="left">
            <div
                class="sl-order-tools__button"
                :class="{ 'cursor-not-allowed opacity-50': disabled }"
                @click="onClick"
            >
                <template v-if="loading">
                    <img src="/img/loader.gif" class="w-5 h-5" />
                </template>

                <template v-else>
                    <mdi-icon icon="mdiRocketLaunch" />
                </template>
            </div>

            <template #content>
                {{ parameter.form_label }}
            </template>
        </tippy>
    </teleport>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useToast } from 'vue-toastification';
import { fieldProps } from '@/composables/FieldComposable';
import LensOrderUrlManager from '@/views/order/lenses/LensOrderUrlManager.js';
import FormPrototype from '@/models/FormPrototype';

// ------------------------------------------------------------ PROPS

const props = defineProps(fieldProps);

// ------------------------------------------------------------ COMPOSABLES

const store = useStore();
const router = useRouter();
const route = useRoute();
const { t } = useI18n({ useScope: 'global' });
const toast = useToast();

// ------------------------------------------------------------ DATA

const loading = ref(false);

// ------------------------------------------------------------ COMPUTED

/** @type {import("vue").ComputedRef<FormPrototype>} */
const proto = computed(
    () => store.getters['lensOrder/getPrototype'](props.side)
);

const disabled = computed(() => loading.value);

// ------------------------------------------------------------ METHODS

async function onClick()
{
    if(loading.value)
        return;

    const eid = store.state.account.cEntity.id;
    const target = props.parameter.value;
    const values = proto.value.getValues(true);
    const side = props.side;

    loading.value = true;

    try
    {
        const converted = await proto.value.convert(eid, target, values);

        const um = new LensOrderUrlManager(route);
        um.setPrototypeCode(side, target);
        await router.push({ path: um.getPath() });

        proto.value.setValues(converted, {
            form_display:          'HIDDEN',
            form_splitted_display: 'HIDDEN',
        });

        store.dispatch('lensOrder/template', { side, initValues: converted });
    }
    catch(error)
    {
        toast.error(error.response?.errors ?? target('common.errors.error'));
    }
    finally
    {
        loading.value = false;
    }
}
</script>
